import type { StorageLocationsSortBy } from 'src/apis/storage/types';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const storageLocationsSortByValues = [
  'NAME',
  'LOCATION_BUSINESS_ID',
  'SSO_NAME',
] as const satisfies readonly StorageLocationsSortBy[];

export const yesNoLabels: Record<'true' | 'false', string> = {
  true: 'Yes',
  false: 'No',
};
export const yesNoValues = labelsToValues(yesNoLabels);
export const yesNoOptions = labelsToOptions(yesNoLabels);
